import {
  ROOMW,
  ROOMH,
  ROOMD,
  PJX,
  PJY,
  PJZ,
  SCRNW,
  SCRNH,
  F_S2D,
  F_D2S,
  VLENSSHIFT,
  HLENSSHIFT,
  VHLENSSHIFT,
  DIST,
  PJHEIGHT,
  F_VOFFSET,
  PROPORTION,
  ASPECTRATIO,

  USERINPUTMODELNAME,
  SEARCHMATCHINGMODELDATA,
  SEARCHSELECTEDMODELDATA,
  SEARCHMATCHINGLENSID,
  SEARCHSELECTEDLENSDATA,

  BMMATCHINGMODELDATA,
  BMSELECTEDMODELDATA,
  BMMATCHINGLENSID,
  BMSELECTEDLENSDATA,

  HTMMATCHINGMODELDATA,
  HTMSELECTEDMODELDATA,
  HTMMATCHINGLENSID,
  HTMSELECTEDLENSDATA,

  MATCHINGMODELDATA,
  SELECTEDMODELDATA,
  MATCHINGLENSID,
  SELECTEDLENSDATA,

  CATERADIO,
  CATEVALUE,
  SCREENSIZE,
  LANGUAGE,
  LANGUAGECHECKED,
  SEARCHTABACTIVENAME,
  SET_UNIT,
  SET_OTHER_POSITION,
  SET_GRAPH_ROOMW,
  SET_GRAPH_ROOMH,
  SET_GRAPH_ROOMD,
  SET_GRAPH_PJY,
  SET_GRAPH_SCRNW,
  SET_GRAPH_SCRNH,
  SET_SCREENSIZE,
  SET_BRIGHTNESS,
  SET_VANGLE,
  SET_VANGLEFLAG,
  SET_HANGLE,
  SET_HANGLEFLAG,
  SET_OFFSET,
  SET_FLOOR2BOTTOM,
  SET_SELECTEDLENSDATA_ASPECTRATIO,
  SET_VLENSSHIFT,
  SET_HLENSSHIFT,
  SET_INITSCREENSIZEW,
  SET_INITSCREENSIZEH,
  SET_OLDTX,
  SET_OLDTY,
  SET_PJIMGTYPE,
  SET_GAIN,
  SET_APPLICATION,
  SET_PROJECTORCHECKED,
  SET_THROWDISTANCECHECKED,
  SET_SCREENSIZECHECKED,
  SET_PJZTIP,
  SET_PJXTIP,
  SET_DRAWDATA,
  SET_BLACKDRAWDATA,
  SET_RANGEDRAWDATA,
  SET_BLACKSIZE,
  SET_CENTERPOSITIONINIT,
  SET_CENTERPOINTDATA,
  CHANGE_VIEW,
  SET_PROJECTORCHECKEDSIDE,
  SET_PROJECTORCHECKEDTOP,
  SET_FLTOB,
  SET_FLTOL,
  SET_DASHFLAG,
  SET_DASHDATA,
  SET_DASHDATAREMAIN,
  SET_ISTOUCH,
  SET_THEME,
  SET_ISINFRONTVIEW,
  SET_SCREEN4POINT,
  SET_POSITION,
  SET_SCREENMOVECHECKED,
  SET_TEMVLENSSHIFT,
  SET_ISUSTWALL,
  SET_ISSIMPLE,
  SET_USTPJTOP,
  SET_USTVDRAGFLAG,
  SET_USTLENSHIFTV,
  SET_FINGERTOUCHSTATUS,
  SET_PLATETOPTOCEILING,
  SET_SCREENTOPTOCEILING,
  SET_PLATEBOTTOMTOSCREEN,
  SET_ISLATVIA,
  SELECTRATIODATA,
  SET_KEYSTONEVERTICAL,
  SET_KEYSTONEHORIZONTAL,
  SET_OUTOFSPECVAL,
  SET_ISOUTOFSPEC,
  SET_ISVANGLEOUT,
  SET_REALTHROWDISTANCECHECKED,
  SET_USTLENSTOFRONTPJ,
  SET_SEARCHPARAMS,
  SET_ISFIRSTENTER,
  SET_ISCONFIGURED,
  SET_RATIOSCREENSIZEMIN,
  SET_RATIOSCREENSIZEMAX,
  SET_FLOORFOOTPROJECTORCHECKED,
  SET_CEILINGBOTTOMPROJECTORCHECKED,
  SET_WALLWALLPROJECTORCHECKED
} from './mutations_types.js'

import { getMatchingLensById } from '../common/common.js'

export default {
  [ROOMW] (state, val) {
    state.houseInfo.roomW = val
  },
  [ROOMH] (state, val) {
    state.houseInfo.roomH = val
  },
  [ROOMD] (state, val) {
    state.houseInfo.roomD = val
  },
  [PJX] (state, val) {
    state.graph.pjX = val
  },
  [PJY] (state, val) {
    state.graph.pjY = val
  },
  [PJZ] (state, val) {
    state.graph.pjZ = val
  },
  [SCRNW] (state, val) {
    state.graph.scrnW = val
  },
  [SCRNH] (state, val) {
    state.graph.scrnH = val
  },
  [F_S2D] (state, val) {
    state.graph.f_s2d = val
  },
  [F_D2S] (state, val) {
    state.graph.f_d2s = val
  },
  [VLENSSHIFT] (state, val) {
    state.graph.vLensShift = val
  },
  [HLENSSHIFT] (state, val) {
    state.graph.hLensShift = val
  },
  [VHLENSSHIFT] (state, val) {
    state.graph.vhLensShift = val
  },
  [DIST] (state, val) {
    state.dist = val
  },
  [PJHEIGHT] (state, val) {
    state.pjHeight = val
  },
  [F_VOFFSET] (state, val) {
    state.f_vOffset = val
  },
  [PROPORTION] (state, val) {
    state.proportion = val
  },
  [ASPECTRATIO] (state, val) {
    state.aspectRatio = val
  },

  [USERINPUTMODELNAME] (state, val) {
    state.userInputModelName = val
  },
  [SEARCHMATCHINGMODELDATA] (state, val) {
    state.searchMatchingModelData = val
  },
  [SEARCHSELECTEDMODELDATA] (state, val) {
    state.searchSelectedModelData = val
  },
  [SEARCHMATCHINGLENSID] (state, val) {
    state.searchMatchingLensID = val
  },
  [SEARCHSELECTEDLENSDATA] (state, val) {
    state.searchSelectedLensData = val
  },

  [BMMATCHINGMODELDATA] (state, val) {
    state.bmMatchingModelData = val
  },
  [BMSELECTEDMODELDATA] (state, val) {
    state.bmSelectedModelData = val
  },
  [BMMATCHINGLENSID] (state, val) {
    if (!val || val.length === 0) {
      state.bmMatchingLensID = val
    } else if (val[0].name) {
      state.bmMatchingLensID = val
    } else {
      state.bmMatchingLensID = getMatchingLensById(val, state.selectedModelData.lcdSize)
    }
  },
  [BMSELECTEDLENSDATA] (state, val) {
    state.bmSelectedLensData = val
  },

  [HTMMATCHINGMODELDATA] (state, val) {
    state.htmMatchingModelData = val
  },
  [HTMSELECTEDMODELDATA] (state, val) {
    state.htmSelectedModelData = val
  },
  [HTMMATCHINGLENSID] (state, val) {
    state.htmMatchingLensID = val
  },
  [HTMSELECTEDLENSDATA] (state, val) {
    state.htmSelectedLensData = val
  },

  [MATCHINGMODELDATA] (state, val) {
    state.matchingModelData = val
  },
  [SELECTEDMODELDATA] (state, val) {
    state.selectedModelData = val
    state.position = val.position
  },
  [MATCHINGLENSID] (state, val) {
    if (!val || val.length === 0) {
      state.matchingLensID = val
    } else if (val[0].name) {
      state.matchingLensID = val
    } else {
      state.matchingLensID = getMatchingLensById(val, state.selectedModelData.lcdSize)
    }
  },
  [SELECTEDLENSDATA] (state, val) {
    state.selectedLensData = val
  },
  [CATERADIO] (state, val) {
    state.cateRadio = val
  },
  [CATEVALUE] (state, val) {
    state.cateValue = val
  },
  [SCREENSIZE] (state, val) {
    state.screenSize = val
  },
  [LANGUAGE] (state, val) {
    state.language = val
  },
  [LANGUAGECHECKED] (state, val) {
    state.languageChecked = val
  },
  [SEARCHTABACTIVENAME] (state, val) {
    state.searchTabActiveName = val
  },
  [SET_UNIT] (state, val) {
    state.graph.unit = val
  },
  [SET_OTHER_POSITION] (state, val) {
    state.selectedModelData.position = val
  },
  [SET_GRAPH_ROOMW] (state, val) {
    state.houseInfo.roomW = val
  },
  [SET_GRAPH_ROOMH] (state, val) {
    state.houseInfo.roomH = val
  },
  [SELECTRATIODATA] (state, val) {
    state.selectRatioData = val
  },
  [SET_GRAPH_ROOMD] (state, val) {
    state.houseInfo.roomD = val
  },
  [SET_GRAPH_PJY] (state, val) {
    state.graph.pjY = val
  },
  [SET_GRAPH_SCRNW] (state, val) {
    state.graph.scrnW = val
  },
  [SET_GRAPH_SCRNH] (state, val) {
    state.graph.scrnH = val
  },
  [SET_SCREENSIZE] (state, val) {
    state.screenSize = val
  },
  [SET_BRIGHTNESS] (state, val) {
    state.brightness = val
  },
  [SET_VANGLE] (state, val) {
    state.vAngle = val
  },
  [SET_VANGLEFLAG] (state, val) {
    state.vAngleFlag = val
  },
  [SET_HANGLE] (state, val) {
    state.hAngle = val
  },
  [SET_HANGLEFLAG] (state, val) {
    state.hAngleFlag = val
  },
  [SET_OFFSET] (state, val) {
    state.offset = val
  },
  [SET_FLOOR2BOTTOM] (state, val) {
    state.floor2bottom = val
  },
  [SET_SELECTEDLENSDATA_ASPECTRATIO] (state, val) {
    state.selectedLensData.lcd.aspectRatio = val
  },
  [SET_VLENSSHIFT] (state, val) {
    state.vLensShiftNow = val
  },
  [SET_HLENSSHIFT] (state, val) {
    state.hLensShiftNow = val
  },
  [SET_INITSCREENSIZEW] (state, val) {
    state.initScreenSize.w = val
  },
  [SET_INITSCREENSIZEH] (state, val) {
    state.initScreenSize.h = val
  },
  [SET_OLDTX] (state, val) {
    state.oldT.x = val
  },
  [SET_OLDTY] (state, val) {
    state.oldT.y = val
  },
  [SET_PJIMGTYPE] (state, val) {
    state.pjImgType = val
  },
  [SET_GAIN] (state, val) {
    state.gain = val
  },
  [SET_APPLICATION] (state, val) {
    state.application = val
  },
  [SET_PROJECTORCHECKED] (state, val) {
    state.projectorChecked = val
  },
  [SET_THROWDISTANCECHECKED] (state, val) {
    state.throwDistanceChecked = val
  },
  [SET_SCREENSIZECHECKED] (state, val) {
    state.screenSizeChecked = val
  },
  [SET_PJZTIP] (state, val) {
    state.pjZTip = val
  },
  [SET_PJXTIP] (state, val) {
    state.pjXTip = val
  },
  [SET_DRAWDATA] (state, val) {
    state.drawData = val
  },
  [SET_BLACKDRAWDATA] (state, val) {
    state.blackDrawData = val
  },
  [SET_CENTERPOSITIONINIT] (state, val) {
    state.centerPositionInit = val
  },
  [SET_RANGEDRAWDATA] (state, val) {
    state.rangeDrawData = val
  },
  [SET_CENTERPOINTDATA] (state, val) {
    state.centerPointData = val
  },
  [CHANGE_VIEW] (state, data) {
    state.view = data
  },
  [SET_BLACKSIZE] (state, val) {
    state.blackSize = val
  },
  [SET_PROJECTORCHECKEDSIDE] (state, val) {
    state.projector_checked_side = val
  },
  [SET_PROJECTORCHECKEDTOP] (state, val) {
    state.projector_checked_top = val
  },
  [SET_FLTOB] (state, val) {
    state.flToB = val
  },
  [SET_FLTOL] (state, val) {
    state.flToL = val
  },
  [SET_DASHFLAG] (state, val) {
    state.dashFlag = val
  },
  [SET_DASHDATA] (state, val) {
    state.dashData = val
  },
  [SET_DASHDATAREMAIN] (state, val) {
    state.dashDataRemain = val
  },
  [SET_ISTOUCH] (state, val) {
    state.isTouch = val
  },
  [SET_THEME] (state, val) {
    state.theme = val
  },
  [SET_ISINFRONTVIEW] (state, val) {
    state.isInFrontView = val
  },
  [SET_SCREEN4POINT] (state, val) {
    state.screen4Point = val
  },
  [SET_POSITION] (state, val) {
    state.position = val
  },
  [SET_SCREENMOVECHECKED] (state, val) {
    state.screenMoveChecked = val
  },
  [SET_TEMVLENSSHIFT] (state, val) {
    state.temVLensShift = val
  },
  [SET_ISUSTWALL] (state, val) {
    state.isUSTWall = val
    if (val) {
      state.isOutOfSpec = false
    } else if (!val && state.outOfSpecVal) {
      state.isOutOfSpec = true
    }
  },
  [SET_USTPJTOP] (state, val) {
    state.USTPjTop = val
  },
  [SET_ISSIMPLE] (state, val) {
    state.isSimple = val
  },
  [SET_USTVDRAGFLAG] (state, val) {
    state.USTVDragFlag = val
  },
  [SET_USTLENSHIFTV] (state, val) {
    state.USTLenshiftV = val
  },
  [SET_FINGERTOUCHSTATUS] (state, val) {
    state.fingerTouchStatus = val
  },
  [SET_PLATETOPTOCEILING] (state, val) {
    state.plateTopToCeiling = val
  },
  [SET_SCREENTOPTOCEILING] (state, val) {
    state.screenTopToCeiling = val
  },
  [SET_PLATEBOTTOMTOSCREEN] (state, val) {
    state.plateBottomToScreen = val
  },
  [SET_ISLATVIA] (state, val) {
    state.isLatvia = val
  },
  [SET_KEYSTONEVERTICAL] (state, val) {
    state.keyStoneVertical = val
  },
  [SET_KEYSTONEHORIZONTAL] (state, val) {
    state.keyStoneHorizontal = val
  },
  [SET_ISVANGLEOUT] (state, val) {
    state.isVAngleOut = val
  },
  [SET_OUTOFSPECVAL] (state, val) {
    state.outOfSpecVal = val
  },
  [SET_ISOUTOFSPEC] (state, val) {
    state.isOutOfSpec = val
  },
  [SET_REALTHROWDISTANCECHECKED] (state, val) {
    state.realThrowDistanceChecked = val
  },
  [SET_USTLENSTOFRONTPJ] (state, val) {
    state.ustLensToFrontPj = val
  },
  [SET_SEARCHPARAMS] (state, val) {
    state.searchParams = val
  },
  [SET_ISFIRSTENTER] (state, val) {
    state.isFirstEnter = val
  },
  [SET_ISCONFIGURED] (state, val) {
    state.isConfigured = val
  },
  [SET_RATIOSCREENSIZEMIN] (state, val) {
    state.ratioScreenSizeMin = val
  },
  [SET_RATIOSCREENSIZEMAX] (state, val) {
    state.ratioScreenSizeMax = val
  },
  [SET_FLOORFOOTPROJECTORCHECKED] (state, val) {
    state.floorFootProjectorChecked = val
  },
  [SET_CEILINGBOTTOMPROJECTORCHECKED] (state, val) {
    state.ceilingBottomProjectorChecked = val
  },
  [SET_WALLWALLPROJECTORCHECKED] (state, val) {
    state.wallWallProjectorChecked = val
  }
}
